export const ActiveContentSwitcher = {
  extends: ['Grid', 'Navbar'],
  round: 'C1',
  fontSize: 'Z1',
  templateColumns: 'repeat(7, 1fr)',
  align: 'center center',
  children: [
    {
      icon: 'magicstar',
      title: 'AI Assistant',
      section: 'AI'
    },
    {
      icon: 'content',
      title: 'Artboards',
      section: 'ARTBOARD_TYPES'
    },
    {
      icon: 'fnOutline',
      title: 'Functions',
      section: 'FUNCTION_TYPES'
    },
    {
      icon: 'tree',
      title: 'Design System',
      section: 'DESIGN_SYSTEM_TYPES'
    },
    {
      icon: 'copywritingOutline',
      title: 'State',
      section: 'STATE_TYPES'
    },
    {
      icon: 'folderOutline',
      title: 'Assets',
      section: 'ASSETS_TYPES'
    },
    {
      icon: 'fuse',
      title: 'Integrations',
      section: 'INTEGRATIONS_TYPES'
    }
  ],
  childProps: {
    textAlign: 'center',
    onClick: (ev, el, s) => {
      const activeContent = el.section
      el.call('setSidebarContent', activeContent)
    }
  },
  childExtends: {
    extends: ['NavbarButton', 'NavbarTooltipParent'],
    state: null,
    width: '100%',
    aspectRatio: 'unset',
    padding: 'Z -',
    '@dark': (el, s) =>
      el.section === s.activeContent
        ? {
            color: 'gray15',
            background: 'gray3'
          }
        : undefined,
    '@light': (el, s) =>
      el.section === s.activeContent
        ? {
            color: 'gray15',
            background: 'gray4'
          }
        : undefined,
    theme: (el, s) =>
      el.section !== s.activeContent ? 'transparent' : undefined,
    ':hover': (el, s) =>
      el.section !== s.activeContent
        ? {
            '@dark': {
              color: 'gray15',
              background: 'gray2'
            },
            '@light': {
              color: 'gray15',
              background: 'gray4'
            }
          }
        : undefined
  },
  NavbarTooltip: {
    ignoreChildExtends: true,
    ignoreChildProps: true
  }
}
